// extracted by mini-css-extract-plugin
export default {"hoverableDropdown":"Hyza6h","icon":"bfYQw5 mz-primary-icon"};